import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
	state: {
		userInfo: {},
		loadAnalysisData: {},
		breadcrumbInfo: [],
		projectInfo: {},
		projectStep: 0
	},
	mutations: {
		upDateUserInfo(state, infos) {
			state.userInfo = infos;
		},
		// 记录点击负载分析后的页面数据
		updateLoadAnalysisData(state, infos) {
			state.loadAnalysisData = infos;
		},
		updateBreadCrumbInfo(state, info) {
			state.breadcrumbInfo = info;
		},
		// 记录进入配储、负载的项目详情
		updateProjectInfo(state, info) {
			state.projectInfo = info;
		},
		// 记录项目步骤，避免刷新
		updateProjectStep(state, step) {
			if (state.projectInfo.step) {
				if (state.projectInfo.step - step <= 1) {
					state.projectStep = step;
				} else {
					// state.projectStep = state.projectInfo.step;
				}
			} else {
				state.projectStep = step;
			}
		}
	},
	actions: {},
	modules: {},
	// Vuex 配置
	plugins: [
		createPersistedState({
			key: "userInfo", // 自定义存储键
			// paths: ["user"] // 指定要持久化的模块
			// exclude: ['auth'], // 排除不需要持久化的模块
			storage: window.sessionStorage // 使用 sessionStorage 进行存储
		})
	]
});
